export enum ServiceTypeEnum {
  MAIN_SERVICE = 0,
  SHORT_CUT = 1,
}
